import React, { useState } from "react";
import { Card, Button, Form } from "react-bootstrap";
import "./CareerBoosterPricing.css"; // Isolated right-side CSS
import PriceBreakupModal from "./PriceBreakupModal/PriceBreakupModal";

function CareerBoosterPricing({ scrollToBenefitsTable }) {
  const [showPriceBreakup, setShowPriceBreakup] = useState(false);
  const [activeTab, setActiveTab] = useState("0-8");
  const [addCoverLetter, setAddCoverLetter] = useState(false);

  return (
    <>
      <div className="career-pricing-sticky">
        <Card className="pricing-sticky-card border border-light-subtle shadow-sm rounded-4 overflow-hidden mb-3">
          {/* Experience Tabs */}
          <div className="d-flex border-bottom text-center fw-semibold cursor-pointer">
            <div
              className={`flex-fill py-3 tab-item ${activeTab === "0-8" ? "tab-active" : "bg-light text-muted"}`}
              onClick={() => setActiveTab("0-8")}
            >
              Exp: 0-8 Years
            </div>
            <div
              className={`flex-fill py-3 tab-item ${activeTab === "8+" ? "tab-active" : "bg-light text-muted"}`}
              onClick={() => setActiveTab("8+")}
            >
              Exp: 8+ Years
            </div>
          </div>

          {/* Pricing breakdown Details */}
          <Card.Body className="p-4 plan-body-bg">
            <div className="text-center mb-4">
              <span className="text-muted d-block small mb-1 fw-semibold">
                6 Months Plan
              </span>
              <h2 className="fw-extrabold text-dark m-0 display-6">₹5,427</h2>
              <span className="text-muted small">₹904/month</span>
            </div>

            {/* Cover Letter Addon checkbox */}
            <div className="border rounded-3 p-3 bg-white d-flex align-items-center justify-content-between mb-4">
              <Form.Check
                type="checkbox"
                id="add-cover-letter"
                label={
                  <span className="small fw-semibold text-dark">
                    Add Cover Letter @₹499
                  </span>
                }
                checked={addCoverLetter}
                onChange={(e) => setAddCoverLetter(e.target.checked)}
                className="custom-purple-checkbox"
              />
              <span
                onClick={scrollToBenefitsTable}
                className="text-decoration-none small fw-bold custom-purple-text cursor-pointer"
              >
                Know more
              </span>
            </div>

            {/* Purchase Call To Action actions */}
            <div className="d-flex gap-2 align-items-center mb-3">
              <Button
                variant="outline-light"
                className="cart-btn p-3 d-flex align-items-center justify-content-center rounded-3"
              >
                🛒
              </Button>
              <Button className="w-100 p-3 fw-bold border-0 rounded-3 text-white primary-buy-btn">
                Buy Now
              </Button>
            </div>

            <div className="text-center text-muted small-legal-text mb-3">
              Inclusive of all taxes{" "}
              <span
                onClick={() => setShowPriceBreakup(true)}
                className="text-dark fw-semibold text-decoration-underline ms-1 cursor-pointer"
              >
                view price breakup
              </span>
            </div>

            {/* Security and assurance seal */}
            <div className="d-flex align-items-center justify-content-center gap-2 border-top pt-3 text-muted small-legal-text">
              🛡️ <span>100% Safe and secure payments with foundit</span>
            </div>
          </Card.Body>
        </Card>

        {/* Coupons Card */}
        <Card className="border border-light-subtle shadow-sm rounded-3 cursor-pointer overflow-hidden">
          <Card.Body className="p-3 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2 fw-bold text-dark">
              <span className="text-warning fw-extrabold fs-5">%</span> Apply
              Coupons
            </div>
            <span className="text-muted fw-bold">&gt;</span>
          </Card.Body>
        </Card>
      </div>

      <PriceBreakupModal
        show={showPriceBreakup}
        handleClose={() => setShowPriceBreakup(false)}
      />
    </>
  );
}

export default CareerBoosterPricing;
